import { SupportedLocale, dateString } from "src/js/util/dates";

import Feature from "src/js/stores/user/Feature";
import { Placeholder } from "./Placeholder";
import { Recipient } from "react-migration/domains/sites/typings/Recipient";
import classNames from "clsx";
import hasFeature from "src/js/stores/user/actions/hasFeature";
import { i18n } from "src/js/i18n";
import { letterStore } from "src/js/stores/letter/store";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

interface MainContentProps {
  showValues?: boolean;
}

export const MainContent = ({ showValues }: MainContentProps) => {
  const { t } = useTranslation();
  const usAccess = hasFeature(Feature.usAccess);
  const sentDate = dateString(new Date(), i18n.locale as SupportedLocale);
  const {
    letter: { greeting, bodyText },
    recipients,
    activeRecipientId,
  } = useSnapshot(letterStore);

  const { fullName, propertyAddress, title } =
    recipients?.find((recipient: Recipient) => recipient._id === activeRecipientId) || {};

  return (
    <div data-testid="letter-preview-body">
      <div className={classNames("mt-[76px]")} data-testid="letter-preview-body-date">
        {showValues ? (
          sentDate
        ) : (
          <Placeholder className={classNames("h-5", "w-40")}>{`{{${t("sites.letters.sent_date")}}}`}</Placeholder>
        )}
      </div>

      <div className={classNames("mt-2.5", "flex", "flex-row")} data-testid="letter-preview-body-greeting">
        <span className="mr-1">{greeting}</span>
        {showValues ? (
          fullName
        ) : (
          <Placeholder className={classNames("h-5", "w-48", "mr-1")}>
            {`{{${t("sites.letters.full_name")}}}`}
          </Placeholder>
        )}
        <span>,</span>
      </div>

      <div className={classNames("mt-3", "flex", "flex-row")} data-testid="letter-preview-body-property-address">
        {propertyAddress && (
          <span>
            <span className={classNames("mr-1", "font-bold", "whitespace-nowrap")}>
              {t("sites.letters.property_address") + ":"}
            </span>
            {showValues ? (
              propertyAddress
            ) : (
              <Placeholder className={classNames("font-normal", "h-5", "w-48", "mr-1")}>
                {`{{${t("sites.letters.property_address")}}}`}
              </Placeholder>
            )}
          </span>
        )}
      </div>

      {!usAccess && (
        <div className={classNames("mt-1", "flex", "flex-row")} data-testid="letter-preview-body-title">
          <span className={classNames("mr-1", "font-bold", "whitespace-nowrap")}>
            {t("sites.letters.title_number") + ":"}
          </span>
          {showValues ? (
            title
          ) : (
            <Placeholder className={classNames("font-normal", "h-5", "w-48", "mr-1")}>
              {`{{${t("sites.letters.title_number")}}}`}
            </Placeholder>
          )}
        </div>
      )}

      <div
        className={classNames("mt-4", "whitespace-pre-wrap", "wrap-break-word")}
        data-testid="letter-preview-body-content"
      >
        {bodyText}
      </div>
    </div>
  );
};
